var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFourActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 76,
    viewBox: "0 0 55 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4176_21332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 51C41.3071 51 52.5 39.8071 52.5 26C52.5 12.1929 41.3071 1 27.5 1C13.6929 1 2.5 12.1929 2.5 26C2.5 39.8071 13.6929 51 27.5 51Z",
    fill: "white",
    stroke: "#FF955A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2958 16.7464C31.8709 18.1393 38.6916 15.3268 38.1165 13.9338C37.5415 12.5408 35.5488 12.0398 33.6662 12.8179C31.7836 13.5941 30.7208 15.3534 31.2958 16.7464Z",
    fill: "#644319"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3248 16.7464C23.7498 18.1393 16.9291 15.3268 17.5041 13.9338C18.0791 12.5408 20.0718 12.0398 21.9545 12.8179C23.8371 13.5941 24.8999 15.3534 24.3248 16.7464Z",
    fill: "#644319"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9036 20.9636C23.0401 19.8629 21.4403 20.0717 20.1308 21.3641C18.8706 20.233 17.4169 20.0584 16.6312 21.0585C15.7013 22.2447 16.06 24.6245 17.434 26.3762C18.4683 27.6933 19.7797 28.2778 20.7627 27.9836C21.5712 27.8527 22.4461 27.3042 23.1749 26.3762C24.5489 24.6245 24.8753 22.201 23.9036 20.9636Z",
    fill: "#644319"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0862 20.9636C38.2227 19.8629 36.6229 20.0717 35.3134 21.3641C34.0532 20.233 32.5995 20.0584 31.8138 21.0585C30.8839 22.2447 31.2426 24.6245 32.6166 26.3762C33.6509 27.6933 34.9623 28.2778 35.9454 27.9836C36.7538 27.8527 37.6287 27.3042 38.3575 26.3762C39.7315 24.6245 40.0579 22.201 39.0862 20.9636Z",
    fill: "#644319"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2225 24.692C37.8734 24.692 38.401 24.1644 38.401 23.5135C38.401 22.8626 37.8734 22.335 37.2225 22.335C36.5716 22.335 36.0439 22.8626 36.0439 23.5135C36.0439 24.1644 36.5716 24.692 37.2225 24.692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0399 24.692C22.6908 24.692 23.2184 24.1644 23.2184 23.5135C23.2184 22.8626 22.6908 22.335 22.0399 22.335C21.389 22.335 20.8613 22.8626 20.8613 23.5135C20.8613 24.1644 21.389 24.692 22.0399 24.692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0648 37.1968C23.6871 37.3809 28.0692 47.0654 32.2443 36.8059C32.2443 36.8059 27.5947 35.2041 27.7845 32.9268C27.7845 32.9268 28.1261 35.2041 24.0648 37.1968Z",
    fill: "#644319"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1248 30.7386C31.1248 28.7004 23.7461 28.7004 23.7461 30.7386C23.7461 32.7769 25.3972 34.428 27.4354 34.428C29.4737 34.428 31.1248 32.7769 31.1248 30.7386Z",
    fill: "#644319"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1582 33.8281C15.1582 33.8281 21.4798 41.5105 26.8658 34.4278",
    stroke: "#644319",
    strokeWidth: 1.13869,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1055 33.8281C28.1055 33.8281 34.4271 41.5105 39.8131 34.4278",
    stroke: "#644319",
    strokeWidth: 1.13869,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37603 31.5984C11.8915 31.5984 13.9308 30.4938 13.9308 29.1312C13.9308 27.7686 11.8915 26.6641 9.37603 26.6641C6.86052 26.6641 4.82129 27.7686 4.82129 29.1312C4.82129 30.4938 6.86052 31.5984 9.37603 31.5984Z",
    fill: "#F19A65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0987 31.6931C48.6142 31.6931 50.6534 30.5885 50.6534 29.2259C50.6534 27.8634 48.6142 26.7588 46.0987 26.7588C43.5832 26.7588 41.5439 27.8634 41.5439 29.2259C41.5439 30.5885 43.5832 31.6931 46.0987 31.6931Z",
    fill: "#F19A65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9461 25.25L23.8945 28.6053",
    stroke: "#F19A65",
    strokeWidth: 0.569343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6023 25.25L26.5508 28.6053",
    stroke: "#F19A65",
    strokeWidth: 0.569343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2595 25.25L29.208 28.6053",
    stroke: "#F19A65",
    strokeWidth: 0.569343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4062 64.5898V65.5742H16.5664V66.7695H6.80469V65.5742H10.9297V64.5898H12.4062ZM15.6641 61.6719V62.8086H12.793C13.0977 63.4238 14.1699 63.9805 16.1211 64.0859L15.6523 65.1992C13.5957 65.0586 12.2246 64.4023 11.6797 63.4414C11.1289 64.3965 9.75781 65.0586 7.70703 65.1992L7.22656 64.0859C9.14258 63.9805 10.2383 63.418 10.5547 62.8086H7.70703V61.6719H15.6641ZM15.6406 67.8594V68.9727H7.69531V67.8594H10.918V67.0625H12.418V67.8594H15.6406ZM11.6562 69.2891C13.7188 69.2891 14.9492 69.7812 14.9492 70.6953C14.9492 71.6211 13.7188 72.1133 11.6562 72.1133C9.57031 72.1133 8.38672 71.6211 8.38672 70.6953C8.38672 69.7812 9.57031 69.2891 11.6562 69.2891ZM11.6562 70.2734C10.5078 70.2852 9.92188 70.3906 9.92188 70.6953C9.92188 70.9883 10.5078 71.1289 11.6562 71.1289C12.8164 71.1289 13.3789 70.9883 13.3906 70.6953C13.3789 70.3906 12.8164 70.2852 11.6562 70.2734ZM20.0586 62.1641C21.6875 62.1641 22.8594 63.6406 22.8711 65.9609C22.8594 68.3047 21.6875 69.7695 20.0586 69.7695C18.4297 69.7695 17.2344 68.3047 17.2461 65.9609C17.2344 63.6406 18.4297 62.1641 20.0586 62.1641ZM20.0586 63.5117C19.2383 63.5117 18.6875 64.3789 18.6875 65.9609C18.6875 67.5547 19.2383 68.4102 20.0586 68.4102C20.8906 68.4102 21.4297 67.5547 21.4414 65.9609C21.4297 64.3789 20.8906 63.5117 20.0586 63.5117ZM25.6016 61.4141V65.4336H27.1719V66.6758H25.6016V72.0781H24.1016V61.4141H25.6016ZM32.7031 63.043V64.2266H27.5469V63.043H29.3984V61.707H30.875V63.043H32.7031ZM30.1484 64.707C31.5078 64.707 32.4805 65.7617 32.4922 67.2383C32.4805 68.7266 31.5078 69.7812 30.1484 69.7812C28.7891 69.7812 27.793 68.7266 27.793 67.2383C27.793 65.7617 28.7891 64.707 30.1484 64.707ZM30.1484 65.9492C29.5273 65.9492 29.1055 66.4297 29.1055 67.2383C29.1055 68.0469 29.5273 68.5156 30.1484 68.5156C30.7461 68.5156 31.168 68.0469 31.1797 67.2383C31.168 66.4297 30.7461 65.9492 30.1484 65.9492ZM36.7812 61.4141V72.0781H35.3633V66.9453H34.4961V71.6211H33.1016V61.625H34.4961V65.75H35.3633V61.4141H36.7812ZM47.6914 69.6055V70.8359H37.9297V69.6055H40.1094V66.9922C39.2832 66.5 38.7852 65.7441 38.7852 64.8008C38.7852 63.0781 40.4727 61.9297 42.793 61.9297C45.1016 61.9297 46.8008 63.0781 46.8125 64.8008C46.8066 65.7207 46.3203 66.4707 45.5234 66.9688V69.6055H47.6914ZM42.793 63.1133C41.2695 63.1133 40.2617 63.7227 40.2617 64.8008C40.2617 65.8438 41.2695 66.4883 42.793 66.4883C44.3047 66.4883 45.3242 65.8438 45.3359 64.8008C45.3242 63.7227 44.3047 63.1133 42.793 63.1133ZM41.5859 69.6055H44.0117V67.5312C43.6309 67.6074 43.2207 67.6484 42.793 67.6484C42.3652 67.6484 41.9609 67.6133 41.5859 67.5312V69.6055Z",
    fill: "#111111"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4176_21332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(1.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourActive);
export default __webpack_public_path__ + "static/media/fourActive.ab3d380c472db0833dceadc8f5f64ff1.svg";
export { ForwardRef as ReactComponent };